// Node Module Imports
import React, { useState } from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

// Style Imports
import {
  above, colors, fontSize, space,
} from '../../style/design-system'

const NavSub = ({
  className, closeMobileNav, isExpanded, listToRender, slugAndParams,
}) => {
  // Calls a function two levels up that closes the mobile navigation when clicking a link
  // Without this functionality, the mobile nav would remain open when clicking a mobile nav Link thst routes to the current location
  const clickHandler = () => {
    if (closeMobileNav) {
      closeMobileNav()
    }
    else {
      return null
    }
  }

  const renderLinks = (arr) => arr.map((link) => {
    const rand = Math.random()
    return (
      <li className="subnav-li" key={rand}>
        {link.state ? (
          <Link
            className={slugAndParams === link.href
              ? 'subnav-link pointer d-block active-link'
              : 'subnav-link pointer d-block'}
            to={link.href}
            state={link.state}
            onClick={clickHandler}>
            {link.text}
          </Link>
        ) : (
          <Link
            className={slugAndParams === link.href
              ? 'subnav-link pointer d-block active-link'
              : 'subnav-link pointer d-block'}
            to={link.href}
            onClick={clickHandler}>
            {link.text}
          </Link>
        )}
      </li>
    )
  })

  return (
    <div className={isExpanded ? `${className} expanded` : `${className}`}>
      <ul>
        {renderLinks(listToRender)}
      </ul>
    </div>
  )
}

export default styled(NavSub)`
  position: relative;
  max-height: 0;
  padding: 0 1.25rem;
  overflow: hidden;
  transition: all .2s ease-in-out;

  ${above.lg`
    position: absolute;
    top: 190%;
    left: -50px;
    width: 21rem;
  `}

  &.expanded {
    max-height: 31.25rem;
    padding: .625rem 1.25rem;
  }

  ul {
    border-radius: 1px;
    padding: 0;
    position: relative;

    ${above.lg`
      background-color: ${colors.umaLightGray};
      box-shadow: 0 0 2px ${colors.dev.gray.a(0.25)}, 4px 4px 8px ${colors.dev.gray.a(0.25)};
      font-size: ${fontSize.f};
      // padding: 1px ${space.g};
    `}

    &::before {
      background-color: ${colors.umaLightGray};
      border-radius: 1px;
      box-shadow: -2px -2px 2px ${colors.dev.gray.a(0.25)};
      content: '';
      display: none;
      height: 14px;
      position: absolute;
        top: -6px; left: ${space.g};
      transform: rotate(45deg);
      width: 14px;
      z-index: -1;

      ${above.lg`
        display: inline-block;
      `}
    }
  }

  .subnav-li {
    list-style: none;

    .subnav-link {
      color: ${colors.dev.gray.b()};
      padding: ${space.b} ${space.b};

      ${above.lg`
        padding: ${space.e} ${space.g};
      `}

      &:active,
      &:focus,
      &:hover {
        background-color: ${colors.dev.blue.d()};
        color: ${colors.dev.gray.i()};
        text-decoration: none;
      }
    }

    .active-link {
      color: ${colors.dev.blue.a()};
    }
  }
`

// TODO: Get a proper key prop for the JSX returned from renderLinks
